import {
  GET_CREDIT_MEMO_REQUEST,
  GET_CREDIT_MEMO_SUCCESS,
  GET_CREDIT_MEMO_ERROR,
  GET_JOURNAL_VOUCHER_REQUEST,
  GET_JOURNAL_VOUCHER_SUCCESS,
  GET_JOURNAL_VOUCHER_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getcreditMemoReportNew = (token, values) => (dispatch) => {

  dispatch({ type: GET_CREDIT_MEMO_REQUEST });
  const newData = {
    from_date: moment(values.from_date).format("MM-DD-YYYY"),
    to_date: moment(values.to_date).format("MM-DD-YYYY"),
    memo_header_no: values.credit_memo === undefined ? null : values.credit_memo,
    customer_id: (values.customer === undefined || values.customer === "" || values.customer === "All") ? null : values.customer,
    term_id: values.terms === "All" || values.terms === undefined ? null : values.terms,
    gender_id: values.gender === "All" ? null : values.gender,
    account_id: values.account === "All" ? null : values.account,
  };
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/CreditMemoSummaryAr`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {
      return dispatch({
        type: GET_CREDIT_MEMO_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_CREDIT_MEMO_ERROR,
        payload: [],
      });
    });
};

export const getJLVoucherReport = (token, values) => (dispatch) => {

  dispatch({ type: GET_JOURNAL_VOUCHER_REQUEST });
  const newData = {
    from_date: moment(values.from_date).format("MM-DD-YYYY"),
    to_date: moment(values.to_date).format("MM-DD-YYYY"),
    voucher_header_no: values.voucher === undefined ? null : values.voucher,
    gender_id: values.gender === "All" ? null : values.gender,
    customer_id: (values.customer === undefined || values.customer === "" || values.customer === "All") ? null : values.customer,
  };
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/GLVoucherReportAr`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {
      return dispatch({
        type: GET_JOURNAL_VOUCHER_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_JOURNAL_VOUCHER_ERROR,
        payload: [],
      });
    });
};
